import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeNutShape, updateSts } from './NutShapeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function NutShapePageList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const NutShape = useSelector(
    (state: AppState) => state.NutShapes
  );

  useEffect(() => {
    if (NutShape.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: NutShape.success.data,
      });

      dispatch(updateSts({}));
    } else if (NutShape.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: NutShape.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [NutShape])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeNutShape(id));
    /* messageApi.open({
      type: 'success',
      content: 'Nut Shape deleted successfully',
    }); */
  };
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={NutShape.NutShape}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>

          <div className='main_class'>
            <p className='sub_data'><b>shape:</b> {item.shape_name} <br /> <b>code:</b> {item.shape_code} </p>
          </div>
        </List.Item>
      )}
    />
  );
}